import { createContext, useContext, useEffect } from "react"
import { GoButton, MutateButton, useLocation } from "@imago/api-client-for-react"
import { Register } from "./Register.tsx"
import { Home } from "./Home.tsx"
import { Community } from './Community/index.tsx'
import { GAHT } from "./GAHT/index.tsx"
import { Services } from "./Services/index.tsx"
import { Surgeries } from "./Surgeries/index.tsx"
import { AccountSettings } from "./Account.tsx"
import { useConfig, useOver18, useProfile } from "../api.ts"
import { installationIcon, useInstallApp } from "@imago/api-client-for-react/pwa"
import { AppInstallBanner } from './PWA.tsx'

export function PatientsApp() {
	const profile = useProfile()

	if (profile === undefined) return
	return !profile ? <Register/> : <RegisteredPatientsApp/>
}

export const PageContext = createContext<string>('')

function RegisteredPatientsApp() {
	const location = useLocation()
	const page = location.pathname.substring(1)

	return <>
		<PageContext value={page}>
			<_RegisteredPatientsApp/>
		</PageContext>
	</>
}

function _RegisteredPatientsApp() {
	useEffect(() => {
		document.documentElement.classList.remove('light-only')
	}, [])

	const over18 = useOver18()

	const page = useContext(PageContext)
	const installApp = useInstallApp()

	const config = useConfig()

	const topLevelPage = page.split('/')[0]

	return <><AppInstallBanner/><div id="tab-container">
		<nav role="tablist">
			<GoButton href="/" role="tab" aria-selected={topLevelPage === '' ? true : undefined} aria-controls="home">
				<span className="material-symbols-outlined">home</span>
				<span>Home</span>
			</GoButton>
			{over18 ? <>
				<GoButton href="/community" role="tab" aria-selected={topLevelPage === 'community' ? true : undefined} aria-controls="community">
					<span className="material-symbols-outlined">diversity_3</span>
					<span>Community</span>
				</GoButton>
			</> : <></>}
			<GoButton href="/gaht" role="tab" aria-selected={topLevelPage === 'gaht' ? true : undefined} aria-controls="gaht">
				<span className="material-symbols-outlined">medical_services</span>
				<span>GAHT</span>
			</GoButton>
			<GoButton href="/services" role="tab" aria-selected={topLevelPage === 'services' ? true : undefined} aria-controls="services">
				<span className="material-symbols-outlined">call</span>
				<span>Services</span>
			</GoButton>
			{config.enableSurgeries ? <>
			<GoButton href="/surgeries" role="tab" aria-selected={topLevelPage === 'surgeries' ? true : undefined} aria-controls="surgeries">
				<span className="material-symbols-outlined">surgical</span>
				<span>Surgeries</span>
			</GoButton>
			</> : <></>}
			<div className="only-on-medium-plus" style={{flex: '1'}}></div>
			<MutateButton role="tab" className="only-on-medium-plus" mutation={installApp}>
				<span className="material-symbols-outlined">{installationIcon()}</span>
				<span>Install app</span>
			</MutateButton>
		</nav>
		<div id="tabs">
			<div id="home" role="tabpanel" hidden={topLevelPage !== ''}>
				<Home/>
			</div>
			<div id="community" role="tabpanel" hidden={topLevelPage !== 'community'}>
				<Community fullScreen={true}/>
			</div>
			<div id="gaht" role="tabpanel" hidden={topLevelPage !== 'gaht'} data-subpage-open={page.startsWith('gaht/') ? true : undefined}>
				<GAHT fullScreen={true}/>
			</div>
			<div id="services" role="tabpanel" hidden={topLevelPage !== 'services'}>
				<Services fullScreen={true}/>
			</div>
			<div id="surgeries" role="tabpanel" hidden={topLevelPage !== 'surgeries'}>
				<Surgeries fullScreen={true}/>
			</div>
			<div id="account" role="tabpanel" hidden={topLevelPage !== 'account'}>
				<AccountSettings/>
			</div>
		</div>
	</div></>
}
